// src/hosts/hostsApi.ts
import { apiClient } from "@maat/api-base";
var hostsApi = {
  getHostProfile: async (workspaceId) => {
    return apiClient.get(`/main/api/hosts/${workspaceId}`);
  },
  getHostListings: async (workspaceId, params) => {
    return apiClient.get(`/main/api/hosts/${workspaceId}/listings`, { params });
  },
  /**
   * Grouped by city. `perCity` caps each group and orders the busiest city first —
   * for a page drawing one carousel per city. Omit it for the whole catalogue,
   * which is what an A–Z list and a "Hosts N places in …" line need.
   */
  getHostListingGroups: async (workspaceId, params) => {
    return apiClient.get(`/main/api/hosts/${workspaceId}/listings`, {
      params: { groupBy: "city", ...params }
    });
  }
};

export {
  hostsApi
};
